import React from 'react';

export interface PageHeaderProps {
  title: string;
  subtitle: string;
  /** Optional action slot rendered top-right */
  children?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, children }) => {
  return (
    <header className="relative mb-7 flex flex-wrap items-start justify-between gap-6">
      <div>
        <h1 className="m-0 text-[22px]/[28px] font-semibold tracking-[-0.088px] text-foreground">
          {title}
        </h1>
        <p className="mt-1 mb-0 max-w-[520px] text-body-sm-regular leading-relaxed text-muted-foreground">{subtitle}</p>
      </div>
      {children ? <div className="flex items-center gap-3">{children}</div> : null}
    </header>
  );
};
